export const DAMAGE_TYPE_KEYS = Object.freeze({
  scratch: 'damage_control.damage_types.scratch',
  dent: 'damage_control.damage_types.dent',
  crack: 'damage_control.damage_types.crack',
  chip: 'damage_control.damage_types.chip',
  missing_part: 'damage_control.damage_types.missing_part',
  other: 'damage_control.damage_types.other',
});

export const FINDING_STATUS_KEYS = Object.freeze({
  confirmed: 'damage_control.review.status_confirmed',
  rejected: 'damage_control.review.status_rejected',
});

export const damageTypeKey = (value) => DAMAGE_TYPE_KEYS[value] || DAMAGE_TYPE_KEYS.other;
export const findingStatusKey = (value) => FINDING_STATUS_KEYS[value] || FINDING_STATUS_KEYS.rejected;
